import { history, useIntl, useModel } from '@umijs/max';
import { Button, Card, Result } from 'antd';
import React from 'react';
import { getActingAsMerchantOwner } from '@/models/actingAsMerchant';
import { getRoleHomePath } from '@/utils/navigation';

/**
 * Custom 403 rendered by the layout plugin when a route's access check fails
 * (wired via the `unAccessible` runtime config in app.tsx). Replaces UmiJS's
 * built-in hardcoded-Chinese fallback with i18n text and a way home.
 */
const ForbiddenPage: React.FC = () => {
  const intl = useIntl();
  const { initialState } = useModel('@@initialState');
  const role =
    initialState?.currentUser?.role || initialState?.currentUser?.access;

  return (
    <Card variant="borderless">
      <Result
        status="403"
        title="403"
        subTitle={intl.formatMessage({
          id: 'pages.403.subTitle',
          defaultMessage: 'Sorry, you are not authorized to access this page.',
        })}
        extra={
          <Button
            type="primary"
            onClick={() =>
              history.push(getRoleHomePath(role, !!getActingAsMerchantOwner()))
            }
          >
            {intl.formatMessage({
              id: 'pages.403.buttonText',
              defaultMessage: 'Back to Home',
            })}
          </Button>
        }
      />
    </Card>
  );
};

export default ForbiddenPage;
